import React from "react";
import { Row, Col, Label, Input } from "reactstrap";

// Campos opcionales del proveedor (los que vienen de SAE + datos bancarios).
// Lo usan el alta (ProveedoresCreate) y la edicion (ListadoProveedores).

export const EXTRA_PROVEEDOR_VACIO = {
  claveSAE: "",
  telefono2: "",
  cuentaContable: "",
  formaPago: "",
  regimenFiscal: "",
  banco: "",
  numCuenta: "",
  clabe: "",
};

export const extraDeProveedor = (p) =>
  Object.keys(EXTRA_PROVEEDOR_VACIO).reduce((o, k) => ({ ...o, [k]: p[k] || "" }), {});

const REGIMENES = [
  ["601", "General de Ley Personas Morales"],
  ["603", "Personas Morales con Fines no Lucrativos"],
  ["605", "Sueldos y Salarios"],
  ["606", "Arrendamiento"],
  ["610", "Residentes en el Extranjero"],
  ["612", "Personas Físicas con Actividades Empresariales"],
  ["616", "Sin obligaciones fiscales"],
  ["621", "Incorporación Fiscal"],
  ["625", "Plataformas Tecnológicas"],
  ["626", "Régimen Simplificado de Confianza"],
];

function DatosAdicionalesProveedor({ extra, setExtra }) {
  const set = (campo, valor) => setExtra((prev) => ({ ...prev, [campo]: valor }));
  const clabeIncompleta = extra.clabe && !/^\d{18}$/.test(extra.clabe);

  return (
    <>
      <Row>
        <Col md={2}>
          <Label>Clave SAE</Label>
          <Input type="text" value={extra.claveSAE} onChange={(e) => set("claveSAE", e.target.value)} />
        </Col>
        <Col md={2}>
          <Label>Teléfono 2</Label>
          <Input type="text" value={extra.telefono2} onChange={(e) => set("telefono2", e.target.value)} />
        </Col>
        <Col md={2}>
          <Label>Cuenta contable</Label>
          <Input type="text" value={extra.cuentaContable} onChange={(e) => set("cuentaContable", e.target.value)} />
        </Col>
        <Col md={2}>
          <Label>Forma de pago</Label>
          <Input type="select" value={extra.formaPago} onChange={(e) => set("formaPago", e.target.value)}>
            <option value="">Selecciona</option>
            <option value="Efectivo">Efectivo</option>
            <option value="Transferencia">Transferencia</option>
            <option value="Cheque">Cheque</option>
            <option value="Otros">Otros</option>
          </Input>
        </Col>
        <Col md={4}>
          <Label>Régimen fiscal</Label>
          <Input type="select" value={extra.regimenFiscal} onChange={(e) => set("regimenFiscal", e.target.value)}>
            <option value="">Selecciona</option>
            {REGIMENES.map(([c, n]) => (
              <option key={c} value={c}>
                {c} {n}
              </option>
            ))}
          </Input>
        </Col>
      </Row>
      <br />
      <Row>
        <Col md={3}>
          <Label>Banco</Label>
          <Input type="text" value={extra.banco} onChange={(e) => set("banco", e.target.value)} />
        </Col>
        <Col md={3}>
          <Label>Número de cuenta</Label>
          <Input type="text" value={extra.numCuenta} onChange={(e) => set("numCuenta", e.target.value)} />
        </Col>
        <Col md={4}>
          <Label>CLABE</Label>
          <Input
            type="text"
            maxLength={18}
            placeholder="18 dígitos"
            value={extra.clabe}
            invalid={!!clabeIncompleta}
            onChange={(e) => set("clabe", e.target.value.replace(/\D/g, ""))}
          />
          {clabeIncompleta && <small className="text-danger">La CLABE debe tener 18 dígitos</small>}
        </Col>
      </Row>
    </>
  );
}

export default DatosAdicionalesProveedor;
